// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__z9te4","imageUploader":"EGiftCard_imageUploader__19Dut"};